import { IEdoStudent } from "@/shared/model/edo-student.model";
import { Card } from "@/components/ui";
import axios from "axios";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip
);

export const options = {
  responsive: true,
  plugins: {
    title: {
      display: true,
    },
  },
  layout: {
    padding: 20,
  },
};

interface IDataFromServer {
  day: string;
  timeSpent: string;
}

interface IData {
  x: string;
  y: number;
}

interface ITimingChartProps {
  student: IEdoStudent;
}

const TimingChart = (props: ITimingChartProps) => {
  const [data, setData] = useState({
    datasets: [
      {
        label: "Minuti in piattaforma",
        data: [] as IData[],
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
    ],
  });

  const { student } = props;

  useEffect(() => {
    const getTimeSpentByChild = async () => {
      const response = await axios.get<{ data: IDataFromServer[] }>(
        `/students/${student?.userId}/time-spent`
      );
      const days: Record<string, number> = {};
      for (let i = 6; i >= 0; i--) {
        const day = new Date();
        day.setDate(day.getDate() - i);
        days[day.toISOString().split("T")[0]] = 0;
      }

      for (const day of response.data.data) {
        const [hours, minutes] = day.timeSpent.split(":").map(Number);
        days[day.day.split("T")[0]] = hours * 60 + minutes;
      }
      setData((prevState) => ({
        ...prevState,
        datasets: [
          {
            ...prevState.datasets[0],
            data: Object.entries(days).map(([day, timeSpent]) => ({
              x: new Intl.DateTimeFormat("it-IT").format(new Date(day)),
              y: timeSpent,
            })),
          },
        ],
      }));
    };
    if (student?.userId) getTimeSpentByChild();
  }, [student?.userId]);

  return (
    <Card className="overflow-hidden rounded-3xl text-[var(--color-mockup-text-mid)]">
      <div className="grid w-full grid-rows-[min-content_min-content]">
        <div className="border-b border-[var(--color-mockup-border)] px-4 py-3 dark:border-[var(--color-mockup-border)]">
          <h3 className="text-heading font-semibold text-[var(--color-mockup-text)]">
            Tempo in piattaforma
          </h3>
        </div>
        <div className="p-4">
          <Bar options={options} data={data} />
        </div>
      </div>
    </Card>
  );
};

export default TimingChart;
